import { TranslateLoader } from '@ngx-translate/core';
import { catchError, Observable, of } from 'rxjs';
import { inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { APP_BASE_HREF } from '@angular/common';

export class CaTranslationLoader implements TranslateLoader {
  #httpClient = inject(HttpClient);
  #appBaseHref = inject(APP_BASE_HREF);

  getTranslation(lang: string): Observable<Object> {
    return this.#httpClient.get(`${ this.#appBaseHref }assets/i18n/${ lang }.json`).pipe(
        catchError(() => {
          console.error(
              `Couldn't either load or parse translation file for lang: ${ lang }. ` +
              `You might not have the translations for this language or ` +
              `you forgot to remove comma at the end of the last key in the translation file.`);
          return of({});
        }),
    );
  }
}
